/**
 * The academic year currently in progress. It turns over on 1 July, so
 * January-June still belongs to the year that began the previous July. Read in
 * UTC so the boundary doesn't shift with the viewer's timezone.
 */
export const currentAcademicYear = (): number => {
  const now = new Date();

  return now.getUTCMonth() >= 6 ? now.getUTCFullYear() : now.getUTCFullYear() - 1;
};

export const GRADUATION_YEARS_OFFERED = 10;

export const PROGRAM_START_YEARS_OFFERED = 11;

/**
 * Graduation years a student still in their program can pick, earliest first.
 * Starts the year after the current one: a graduation year that has passed
 * means the student has finished.
 */
export const graduationYearOptions = (): number[] => {
  const firstYear = currentAcademicYear() + 1;

  return Array.from({ length: GRADUATION_YEARS_OFFERED }, (_, offset) => firstYear + offset);
};

/**
 * Program start years, latest first. Runs a year ahead of the current one,
 * since a program that hasn't started yet is a real state.
 */
export const programStartYearOptions = (): number[] => {
  const firstYear = currentAcademicYear() + 1;

  return Array.from({ length: PROGRAM_START_YEARS_OFFERED }, (_, offset) => firstYear - offset);
};

/**
 * The offered years plus the one already on file, if the range or a narrowing
 * filter left it out — a select whose value is absent from its options renders blank.
 */
export const withSavedYear = (years: number[], saved?: string | number | null): number[] => {
  const savedYear = saved === null || saved === undefined || saved === '' ? null : Number(saved);

  if (savedYear === null || !Number.isInteger(savedYear) || years.includes(savedYear)) return years;

  const descending = years.length > 1 && years[1] < years[0];

  return [...years, savedYear].sort((a, b) => (descending ? b - a : a - b));
};
